<template>
  <tr>
    <td>
      <el-date-picker
        type="datetime"
        :editable="false"
        v-model="date"
        @change="dateUpdated"
        >
      </el-date-picker>
    </td>
    <td>
      <b-input v-model="row.reason" @change="handleUpdate"/>
    </td>
    <td>
      <el-date-picker
        @change="dateUpdated"
        :editable="false"
        v-model="disclosureFailureDate"
        type="date">
      </el-date-picker>
    </td>
    <td>
      <b-input v-model="row.renewalInformation" @change="handleUpdate"/>
    </td>
    <td>
      <el-date-picker
        @change="dateUpdated"
        :editable="false"
        v-model="disclosureRenewalDate"
        type="date">
      </el-date-picker>
    </td>
    <td>
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRequiredInformationRow(row)"/>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BankRequirementRow',
  data () {
    return {
      updateTimer: null,
      date: '',
      disclosureFailureDate: '',
      disclosureRenewalDate: ''
    }
  },
  props: {
    row: {
      required: true
    }
  },
  created () {
    this.date = this.row.date
    this.disclosureRenewalDate = this.row.disclosureRenewalDate
    this.disclosureFailureDate = this.row.disclosureFailureDate
  },
  methods: {
    ...mapActions(['deleteRequiredInformationRow', 'updateRequiredInformationRow']),
    handleUpdate () {
      this.updateRequiredInformationRow(this.row)
    },
    dateUpdated () {
      this.row.date = this.date
      this.row.disclosureRenewalDate = this.disclosureRenewalDate
      this.row.disclosureFailureDate = this.disclosureFailureDate
      this.handleUpdate()
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100% !important;
}
.delete-icon {
  height: 24px;
  min-width: 24px;
  position: initial;
}
td {
  padding: 4px 12px 4px 0;
}
</style>



// WEBPACK FOOTER //
// BankRequirementRow.vue?5704c3c4